module.exports = __webpack_public_path__ + "static/media/ficha.6600948a.svg";